module.exports = __webpack_public_path__ + "img/orangeCircle.c56ed1d7.png";